import {create} from 'zustand';

interface StoreState {
    walletReady: boolean
    setWalletReady: (inited: boolean) => void,
    tgAppAuthCode: string
    setTgAppAuthCode: (code: string) => void,
    emailLoginKey: string
    setEmailLoginKey: (key: string) => void,

}

const useStore = create<StoreState>(set => ({
    walletReady: false,
    setWalletReady: (inited) => set({walletReady: inited}),
    tgAppAuthCode: '',
    setTgAppAuthCode: (code) => set({tgAppAuthCode: code}),
    emailLoginKey: '',
    setEmailLoginKey: (key) => set({emailLoginKey: key}),
}));

export default useStore;
